import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { ROLE_QUERY_KEYS } from './keys';

import type { RoleItem } from 'pages/settings/users/userPermissions/types';
import * as roleService from 'services/role';

export const useRolesQuery = (): UseQueryResult<RoleItem[], Error> => {
  return useQuery<RoleItem[], Error>({
    queryKey: [ROLE_QUERY_KEYS.ROLES],
    queryFn: roleService.fetchAll,
    select: (roles) => [...roles].sort((left, right) => (left.name ?? '').localeCompare(right.name ?? '')),
  });
};
